import slugify from 'slugify';

export default function createSlug(text) {
  return slugify(text, {
    lower: true,
  }).replaceAll(/[^a-zA-Z0-9_-]/g, '');
}
